import { CheckIcon, TriangleAlertIcon } from 'lucide-react';
import type { ValidateSchemaResult } from '../../lib/validateSchema';

export function ReportIcon({
  report,
  className = '',
}: {
  report: ValidateSchemaResult;
  className?: string;
}) {
  if (report.problems.length === 0) {
    return (
      <CheckIcon className={`size-4 shrink-0 text-positive-foreground ${className}`} aria-hidden />
    );
  }
  return (
    <TriangleAlertIcon
      className={`size-4 shrink-0 ${
        report.errorCount > 0 ? 'text-destructive' : 'text-warning-foreground'
      } ${className}`}
      aria-hidden
    />
  );
}
